import React, { useContext } from "react";
import { GreenMachineContext } from "../GreenMachineContext";
import "./StepHeading.css";

export default function StepHeading() {
  const { currentStage, STAGE_NUMBERS, activeSlatesExist } = useContext(
    GreenMachineContext
  );

  // The chevron bar now labels each step, so the redundant per-step title and
  // instruction have been removed. Only the no-slates empty state remains.
  if (currentStage === STAGE_NUMBERS.selectSport && !activeSlatesExist) {
    return (
      <div className="gm-step-heading">
        <h2 className="gm-step-heading-title">No Active Slates</h2>
        <p className="gm-step-heading-instruction">
          There aren&apos;t any slates available to build lineups for right now.
          Check back closer to the event.
        </p>
      </div>
    );
  }

  return null;
}
